/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChainTransactionListInfo,
    ChainTransactionListInfoFromJSON,
    ChainTransactionListInfoFromJSONTyped,
    ChainTransactionListInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChainTransactionsResponse
 */
export interface ChainTransactionsResponse {
    /**
     * 
     * @type {Array<ChainTransactionListInfo>}
     * @memberof ChainTransactionsResponse
     */
    list: Array<ChainTransactionListInfo>;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainTransactionsResponse
     */
    totalSize?: number;
}

export function ChainTransactionsResponseFromJSON(json: any): ChainTransactionsResponse {
    return ChainTransactionsResponseFromJSONTyped(json, false);
}

export function ChainTransactionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainTransactionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ChainTransactionListInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function ChainTransactionsResponseToJSON(value?: ChainTransactionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ChainTransactionListInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


